import type { FluentProviderCustomStyleHooks } from '@fluentui/react-components';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { getSlotClassNameProp_unstable } from '@fluentui/react-utilities';

/**
 * App-wide Fluent v9 button min-width override via FluentProvider `customStyleHooks_unstable`.
 *
 * See Fluent Advanced Styling Techniques:
 * https://storybooks.fluentui.dev/react/?path=/docs/concepts-developer-advanced-styling-techniques--docs
 *
 * The `_unstable` suffix is Fluent's naming for this API surface; caller `className` still wins
 * because we merge with `getSlotClassNameProp_unstable` last.
 */
const useButtonMinWidthStyles = makeStyles({
    root: {
        minWidth: 'unset',
    },
});

type SlotWithClassName = {
    root: {
        className?: string;
    };
};

const useButtonMinWidthUnset = (state: unknown) => {
    const styles = useButtonMinWidthStyles();
    const slotState = state as SlotWithClassName;
    slotState.root.className = mergeClasses(slotState.root.className, styles.root, getSlotClassNameProp_unstable(slotState.root));
};

export const fluentCustomStyleHooks: FluentProviderCustomStyleHooks = {
    useButtonStyles_unstable: useButtonMinWidthUnset,
    useMenuButtonStyles_unstable: useButtonMinWidthUnset,
    useToggleButtonStyles_unstable: useButtonMinWidthUnset,
    useCompoundButtonStyles_unstable: useButtonMinWidthUnset,
    useSplitButtonStyles_unstable: useButtonMinWidthUnset,
};
